import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import './demoSettings.scss'

import {
  DEFAULT_SIDEBAR_WIDTH,
  useDemoViewerSettings,
} from '../contexts/DemoViewerSettingsContext'

export const DemoSettings = () => {
  const navigate = useNavigate()
  const { settings, updateSettings } = useDemoViewerSettings()

  const [sidebarWidthInput, setSidebarWidthInput] = useState(String(settings.sidebarWidth))
  const [sidebarAutoCollapse, setSidebarAutoCollapse] = useState(settings.sidebarAutoCollapse)

  const handleSave = () => {
    const parsed = parseInt(sidebarWidthInput, 10)
    const sidebarWidth = !isNaN(parsed)
      ? Math.max(100, Math.min(500, parsed))
      : DEFAULT_SIDEBAR_WIDTH
    updateSettings({ sidebarWidth, sidebarAutoCollapse })
    navigate(-1)
  }

  return (
    <div className='demo-settings-page'>
      <div className='demo-settings-page__header'>
        <button className='demo-settings-page__back' onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1>Demo Settings</h1>
        <span>Persists on local storage.</span>
      </div>

      <div className='demo-settings-page__card'>
        <h2>Sidebar</h2>

        <div className='demo-settings-page__field'>
          <div className='demo-settings-page__field-label'>
            <span>Left sidebar width</span>
            <span className='demo-settings-page__field-description'>
              Width of the left navigation sidebar in pixels (default 232px). Useful when aligning the implementation to be
              closer to the platform we're integrating with.
            </span>
          </div>
          <div className='demo-settings-page__width-input'>
            <input
              type='number'
              min={100}
              max={500}
              value={sidebarWidthInput}
              onChange={(e) => setSidebarWidthInput(e.target.value)}
            />
            <span>px</span>
            <button
              className='demo-settings-page__reset-btn'
              onClick={() => setSidebarWidthInput(String(DEFAULT_SIDEBAR_WIDTH))}
              title={`Reset to default (${DEFAULT_SIDEBAR_WIDTH}px)`}
            >
              Reset
            </button>
          </div>
        </div>

        <div className='demo-settings-page__field'>
          <div className='demo-settings-page__field-label'>
            <span>Auto-collapse on smaller views</span>
            <span className='demo-settings-page__field-description'>
              Sidebar switches to a slide-in drawer on viewports narrower than 992px
            </span>
          </div>
          <label className='demo-settings-page__toggle'>
            <input
              type='checkbox'
              checked={sidebarAutoCollapse}
              onChange={(e) => setSidebarAutoCollapse(e.target.checked)}
            />
            <span className='demo-settings-page__toggle-slider' />
          </label>
        </div>
      </div>

      <div className='demo-settings-page__actions'>
        <button className='admin-button' onClick={handleSave}>Save changes</button>
        <button className='admin-button' onClick={() => navigate(-1)}>Cancel</button>
      </div>
    </div>
  )
}
